<template>
    <section class="application-submission">
        <div class="unsubmitted" v-if="!copiedIsSubmitted">
            <div class="alert alert-warning border-left border-4 border-warning ml-1 mr-1">
                <strong>WARNING:</strong>
                By submitting this application, you attest that all questions have been answered fully, accurately, and truthfully to the best of your ability
                and that you understand failure to meet these requirements may delay the review process or result in a negative early review determination.
            </div>

            <p class="mt-3">
                You've completed all required tasks. Please carefully review your application for accuracy and then submit for review.
            </p>

            <div class="btn btn-primary float-end text-white mt-3" @click="submitApplication">
                Submit Application
            </div>
        </div>

        <div class="submitted" v-else>
            <p>
                <i class="fa-solid fa-check text-success me-2"></i>
                Thank you for submitting your application. You will be contacted by a RadSite administrator.
            </p>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['application_id', 'is_submitted'],
        data() {
            return {
                copiedIsSubmitted: false
            }
        },
        mounted() {
            this.copiedIsSubmitted = _.cloneDeep( this.is_submitted );
        },
        methods: {
            submitApplication() {
                $.ajax({
                    url: localized.resturl + '/application/' + this.application_id + '/submit',
                    method: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader( 'X-WP-Nonce', localized.restnonce );
                    },
                    dataType: 'json',
                    success: (result) => {
                        if(result.success) {
                            this.copiedIsSubmitted = true;
                            toastr.success(result.message, 'Success');
                        } else {
                            toastr.error(result.message, 'Error');
                        }
                    },
                    error: function(result) {
                        toastr.error('An error occurred while submitting the application', 'Error');
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .alert-warning {
        border: 1px solid #f0ad4e;
    }
</style>
